import ITradeBasicInfo from "../ITradeBasicInfo";

interface IGroupOptions {
  value: keyof ITradeBasicInfo;
  description: string;
}

export const groupOptions: IGroupOptions[] = [
  {
    value: "lastUpdate",
    description: "Data Ultima Atualização"
  },
  {
    value: "specialProjectName",
    description: "Projeto Especial"
  },
  {
    value: "phase",
    description: "Fase"
  }
];



// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/groupOptions.ts